/* ----------------------------------------
カスタムJS
---------------------------------------- */

// 即時関数
(function(){

  /* コレクションページ
  ------------------------------ */

  // コレクションページで、read more実装
  const initReadMore = function(){

    // .btn-read-moreがなければ、なにもしない
    if( $('.btn-read-more').length == 0 ){
      return false;
    }

    // bodyにdata-pagenumを追加
    $('body').attr('data-pagenum',1);

    // bodyにdata-pagination-stateを追加
    $('body').attr('data-pagination-state', 'normal');

    // ボタンを押したときの処理実装
    $('.btn-read-more').on('click', async function(){

      // ローディング中はなにもしない
      if( $('body').attr('data-pagination-state') == 'loading' ){
        return false;
      }

      // ステートをローディングに
      $('body').attr('data-pagination-state', 'loading');

      // 読み込むページを取得
      let loadpage = Number($('body').attr('data-pagenum')) + 1;

      // データ読み込み
      console.log(loadpage + 'ページ目の読み込み - 開始');
      let request = $.ajax(window.location.pathname + '?page=' + loadpage);

      // 失敗時の処理
      request.fail(function( jqXHR, textStatus ){
        alert('データの読み込みに失敗しました。');

        // ローディングの解除
        $('body').attr('data-pagination-state', 'normal');
      });

      // 成功時の処理
      request.done(function( data ){

        console.log(loadpage + 'ページ目の読み込み - 完了');

        // 最終ページかどうかフラグ
        let isLastPage = false;

        // #Collectionに[data-is-last-page="true"]があったら、最終ページ
        if( $(data).find('#Collection').attr('data-is-last-page') == "true" ){
          isLastPage = true;
        }

        if(isLastPage){
          console.log(loadpage + 'ページ目は最終ページです。');
        }

        // 画像プリロード
        let preloadImages = [];
        $(data).find('#Collection .grid-view-item__image').each(function(index){
          if(index < 5 ){
            let img = document.createElement('img');
            img.src = $(this).attr('src');
            preloadImages.push(img);
          }
        });

        // 読み込んだデータを追加する
        $('#Collection > ul').append( $(data).find('#Collection > ul > li') );

        // 現在のページを＋１する
        $('body').attr('data-pagenum', loadpage);

        // 最終ページかどうかによりdata-pagination-stateを変更
        if( isLastPage ){
          $('body').attr('data-pagination-state', 'end');
        }else{
          $('body').attr('data-pagination-state', 'normal');
        }

        // ポップアップアニメーションをスタートさせるために、スクロールイベント発火
        $(window).trigger('scroll');
      });
    });
  }
  // コレクションページのファンクション呼び出し
  if( $('body').hasClass('template-collection') ){
    initReadMore();
  }

  /* 商品詳細ページ
  ------------------------------ */
  
  // アコーディオン初期化
  const initAcc = function(){

    // トリガークリック時の処理実装
    $('.acc-group .acc-trigger').on('click', function(e){
      e.preventDefault();

      console.log('clicked!!');

      if( $(this).closest('.acc-group').attr('data-acc-state') == 'close' ){

        console.log('close → open');

        // close → open
        $(this).closest('.acc-group').find('.acc-contents').stop().slideDown(300, function(){
          $(this).closest('.acc-group').attr('data-acc-state', 'open');
        });

      }else{

        console.log('open → close');

        // open → close
        $(this).closest('.acc-group').find('.acc-contents').stop().slideUp(300, function(){
          $(this).closest('.acc-group').attr('data-acc-state', 'close');
        });
      }
    });
  }

  // カスタムバリエーション部分で、「カートに入れる」ボタンを押したときの処理
  const initCustomVariationAddCart = function(){
    $('.custom-variation a[js-addCart]').on('click', function(e){

      e.preventDefault();

      // カラーとサイズの取得
      let color = $(this).attr('data-color');
      let size = $(this).attr('data-size');

      // カラーの選択
      $(this).closest('.custom-variation').next('form').find('input[type="radio"][value="' + color + '"]').click();

      // サイズの選択
      $(this).closest('.custom-variation').next('form').find('input[type="radio"][value="' + size + '"]').click();

      // 「カートに追加する」ボタンを押す
      $(this).closest('.custom-variation').next('form').find('button[type="submit"][name="add"]').click();
    });
  }

  // スマホで、カートに入れるモーダルの閉じるボタン実装
  $('.custom-variation > .inner > .productName-and-price > .btnClose').on('click', function(e){

    e.preventDefault();

    // 背景のクリックイベントを発火
    $('#contact-modal-container').click();

  });

  // スマホでコンテンツ内の「カートに追加する」ボタンを押したときの処理
  $('main .add-cart-sp').on('click', function(e){

    e.preventDefault();

    // ページ下部固定ボタンのクリックイベント呼び出し
    $('main .fixed-button-add-to-card[name="add"]').click();
  });

  const initAdCartBtnShowHide = function(){

    // ロード、スクロールしたとき、コンテンツ内の「カートに追加する」ボタンがウィンドウ領域内にいたら、追随「カートに追加する」ボタンを非表示にする
    $(window).on('load scroll', function(){

      // ウィンドウ幅がPCだったら、なにもしない
      if( $(window).innerWidth() > 768 ){
        return false;
      }

      // コンテンツ内の「カートに追加する」ボタンの取得
      let $btncart_in_contents = $('main .add-cart-sp');

      // 追随「カートに追加する」ボタンの取得
      let $btncart_fixed = $('#AddToCart-fixed-product-template-sp');

      // コンテンツ内の「カートに追加する」ボタンの縦位置取得
      let y_pos = $btncart_in_contents.offset().top;

      // スクロール位置の取得
      let scrolltop =$(window).scrollTop();

      // 画面の高さ取得
      let wh = $(window).innerHeight();

      // コンテンツ内ボタンが、画面内にいるかどうか？
      if(
        scrolltop + wh > y_pos &&  // ウィンドウ最下部が、ボタンの上限位置より大きい（画面に入ってきた）
        scrolltop < y_pos + 44 // スクロールした量が、ボタンの下限位置より小さい（画面から出る前）
      ){
        // 追随カートボタンを非表示にする
        $btncart_fixed.hide();
      }else{
        // 追随カートボタンを表示にする
        $btncart_fixed.show();
      }
    });
  }

  // snapページのデータ読み込み（商品詳細ページ用）
  const loadSnapPageData = function(){

    // pc/spを判断してクラス付与
    if( window.innerWidth <= 749 ){
      $('body').attr('data-device', 'sp');
    }else{
      $('body').attr('data-device', 'pc');
    }

    // データ読み込み
    $.ajax('/pages/snappage').done(function(data){

      console.log('snapページデータ読み込み完了');

      // 最終出力html
      let html = '';

      // ヒット数カウント
      let hit = 0;

      // 該当する商品データ配列
      let $snap_items = $(data).find('.snap-page-wrapper > .snap-page > .snap-page-item');

      $snap_items.each(function(index, item){

        let flag = false;

        // snapitem内のhrefが現在のページとマッチするかの確認
        $(item).find('.snap-page-item-descriptions .snap-page-item-group').each(function(index2, item2){

          // 関連商品のhrefを取得
          let href = $(item2).find('.link > a').attr('href');

          // 現在のページにマッチしていたらフラグを立てる
          if( href && href.match(/[^\/]*$/)[0] == window.location.pathname.match(/[^\/]*$/)[0] ){
            flag = true;
          }
        });

        if( flag ){
          html += $(item).prop('outerHTML');
          hit++;
        }
      });

      // .product-template-size__pcの後にhtmlを追加する
      $('.product-template-size__pc').after(
        '<div class="snap-page-width page-width">' +
        '<p class="product-snap-title">SNAP</p>' +
        '<div class="snap-page-wrapper"><div class="snap-page" data-count="' + hit + '">' + 
        html +
        '<div class="snap-page-item _blank"></div>' + 
        '<div class="snap-page-item _blank"></div>' + 
        '<div class="snap-page-item _blank"></div>' + 
        '<div class="snap-page-item _blank"></div>' + 
        '<div class="snap-page-item _blank"></div>' + 
        '</div>' + 
        '<div class="text-center btn-more"><a href="/pages/snappage" class="btn" aria-label="read more">read more</a></div>' +
        '<div id="snap-view-wrapper" style="display: block;"></div>' +
        '</div></div>'
      );

      // ここから後処理

      // ロードアイテム
      const loadItem = function(resetFlag){

        // 読み込む件数
        let defaultShowCount = 0;
        if( window.innerWidth <= 749 ){
          // spの表示件数は999
          defaultShowCount = 999;
        }else{
          // pcの表示件数は5
          defaultShowCount = 5;
        }

        // resetフラグがあったら、空アイテム以外を非表示に
        if( resetFlag ){
          $('.snap-page-item').each(function(){
            if( !$(this).hasClass('_blank') ){
              $(this).hide();
            }
          });
        }

        // 絞り込みに合致する、非表示のアイテム
        let filteredHiddenItem = [];

        // 絞り込みに合致する、非表示のアイテムを全て取得する
        $('.snap-page-item').each(function(){        
          if( $(this).attr('style') == 'display: none;' && !$(this).hasClass('_blank') ){
            filteredHiddenItem.push($(this));
          }
        });

        // そのうち最初から初期表示件数分を表示する。
        filteredHiddenItem.slice(0, defaultShowCount).map(function($item){
          $item.show();
        });

        // まだ表示するアイテムがあれば、read moreボタンを再表示する
        if( filteredHiddenItem.length > defaultShowCount ){
          $('.snap-page-wrapper .btn-more').show();
        }else{
          $('.snap-page-wrapper .btn-more').hide();
        }
      }
      // resetフラグonで、初回呼び出し
      loadItem(true);

      // read moreボタンを押したときの処理実装
      $('.snap-page-wrapper .btn-more').on('click', function(e){

        e.preventDefault();

        loadItem(false);

        // ボタンをデフォーカス
        $(this).find('a').blur();
      });

      // pc/spをまたいでリサイズしたときの処理
      $(window).on('resize', function(){
        if( $('body').attr('data-device') == 'pc' && window.innerWidth <= 749 ){
          console.log('pc → sp');
          $('body').attr('data-device', 'sp');
          loadItem(true);
        }else if( $('body').attr('data-device') == 'sp' && window.innerWidth >= 750 ){
          console.log('sp → pc');
          $('body').attr('data-device', 'pc');
          loadItem(true);
        }
      });
    });
  }

  // snapページのデータ読み込み（トップページ用）
  const loadSnapPageData2 = function(){

    // データ読み込み
    $.ajax('/pages/snappage').done(function(data){

      console.log('snapページデータ読み込み完了');

      // 読み込む件数
      let defaultShowCount = 6;

      // 最終出力html
      let html = '';

      // 該当する商品データ配列
      let $snap_items = $(data).find('.snap-page-wrapper > .snap-page > .snap-page-item');

      $snap_items.each(function(index, item){
        if( index < defaultShowCount ){
          html += $(item).prop('outerHTML');
        }
      });

      // .index-section--snapとhtmlを差し替える
      $('.index-section--snap').before(
        '<div class="snap-page-width page-width">' +
        '<p class="product-snap-title">SNAP</p>' +
        '<div class="snap-page-wrapper"><div class="snap-page">' + 
        html +
        '<div class="snap-page-item _blank"></div>' + 
        '<div class="snap-page-item _blank"></div>' + 
        '<div class="snap-page-item _blank"></div>' + 
        '<div class="snap-page-item _blank"></div>' + 
        '<div class="snap-page-item _blank"></div>' + 
        '</div>' + 
        '<div class="text-center btn-more"><a href="/pages/snappage" class="btn" aria-label="read more">read more</a></div>' +
        '<div id="snap-view-wrapper" style="display: block;"></div>' +
        '</div></div>'
      );
      $('.index-section--snap').remove();
    });
  }

  // 商品詳細ページのファンクション呼び出し
  if( $('body').hasClass('template-product') ){
    initAcc();
    initCustomVariationAddCart();
    initAdCartBtnShowHide();
  }

  /* SNAPページ
  ------------------------------ */
  const initSnap = function(){

    // ページ読み込み時の処理
    // pc/spを判断してクラス付与
    if( window.innerWidth <= 749 ){
      $('body').attr('data-device', 'sp');
    }else{
      $('body').attr('data-device', 'pc');
    }

    // ロードアイテム
    const loadItem = function(resetFlag){

      // 読み込む件数
      let defaultShowCount = 0;
      if( window.innerWidth <= 749 ){
        // spの表示件数は12
        defaultShowCount = 12;
      }else{
        // pcの表示件数は15
        defaultShowCount = 15;
      }

      // 絞り込みの値を取得
      let selected = $('#tall_selector').val();

      // resetフラグがあったら、空アイテム以外を非表示に
      if( resetFlag ){
        $('.snap-page-item').each(function(){
          if( !$(this).hasClass('_blank') ){
            $(this).hide();
          }
        });
      }

      // 絞り込みに合致する、非表示のアイテム
      let filteredHiddenItem = [];

      // 絞り込みに合致する、非表示のアイテムを全て取得する
      $('.snap-page-item').each(function(){        
        if( selected == '' ){ // 絞り込みがないとき
          if( $(this).attr('style') == 'display: none;' && !$(this).hasClass('_blank') ){
            filteredHiddenItem.push($(this));
          }
        }else{
          if( $(this).attr('data-tall') == selected && $(this).attr('style') == 'display: none;' && !$(this).hasClass('_blank') ){
            filteredHiddenItem.push($(this));
          }
        }
      });

      // そのうち最初から初期表示件数分を表示する。
      filteredHiddenItem.slice(0, defaultShowCount).map(function($item){
        $item.show();
      });

      // まだ表示するアイテムがあれば、read moreボタンを再表示する
      if( filteredHiddenItem.length > defaultShowCount ){
        $('.snap-page-wrapper .btn-more').show();
      }else{
        $('.snap-page-wrapper .btn-more').hide();
      }
    }
    // resetフラグonで、初回呼び出し
    loadItem(true);

    // read moreボタンを押したときの処理実装
    $('.snap-page-wrapper .btn-more').on('click', function(e){

      e.preventDefault();

      loadItem(false);

      // ボタンをデフォーカス
      $(this).find('a').blur();
    });

    // pc/spをまたいでリサイズしたときの処理
    $(window).on('resize', function(){
      if( $('body').attr('data-device') == 'pc' && window.innerWidth <= 749 ){
        console.log('pc → sp');
        $('body').attr('data-device', 'sp');
        loadItem(true);
      }else if( $('body').attr('data-device') == 'sp' && window.innerWidth >= 750 ){
        console.log('sp → pc');
        $('body').attr('data-device', 'pc');
        loadItem(true);
      }
    });

    // 絞り込みを変更したときの処理実装
    $('#tall_selector').on('change', function(){
      loadItem(true);
    })
  }
  // SNAPページのファンクション呼び出し
  if( window.location.pathname.slice(0,11) == '/pages/snap' ){
    initSnap();
  }

  /* BLOGページ
  ------------------------------ */
  const initReadMoreInBlog = function(){

    // .btn-read-moreがなければ、なにもしない
    if( $('.btn-read-more').length == 0 ){
      return false;
    }

    // bodyにdata-pagenumを追加
    $('body').attr('data-pagenum',1);

    // bodyにdata-pagination-stateを追加
    $('body').attr('data-pagination-state', 'normal');

    // ボタンを押したときの処理実装
    $('.btn-read-more').on('click', async function(e){

      e.preventDefault();

      // ローディング中はなにもしない
      if( $('body').attr('data-pagination-state') == 'loading' ){
        return false;
      }

      // ステートをローディングに
      $('body').attr('data-pagination-state', 'loading');

      // 読み込むページを取得
      let loadpage = Number($('body').attr('data-pagenum')) + 1;

      // データ読み込み
      console.log(loadpage + 'ページ目の読み込み - 開始');
      let request = $.ajax(window.location.pathname + '?page=' + loadpage);

      // 失敗時の処理
      request.fail(function( jqXHR, textStatus ){
        alert('データの読み込みに失敗しました。');

        // ローディングの解除
        $('body').attr('data-pagination-state', 'normal');
      });

      // 成功時の処理
      request.done(function( data ){

        console.log(loadpage + 'ページ目の読み込み - 完了');

        // 最終ページかどうかフラグ
        let isLastPage = false;

        // .blog-list-view[data-is-last-page="true"]があったら、最終ページ
        if( $(data).find('.blog-list-view').attr('data-is-last-page') == "true" ){
          isLastPage = true;
        }

        if(isLastPage){
          console.log(loadpage + 'ページ目は最終ページです。');
        }

        // 読み込んだデータを追加する
        $('.blog-list > .blog-list-item.-blank').eq(0).before( $(data).find('.blog-list > .blog-list-item:not(.-blank)') );

        // 現在のページを＋１する
        $('body').attr('data-pagenum', loadpage);

        // 最終ページかどうかによりdata-pagination-stateを変更
        if( isLastPage ){
          $('body').attr('data-pagination-state', 'end');
        }else{
          $('body').attr('data-pagination-state', 'normal');
        }
      });
    });
  }
  // BLOGページのファンクション呼び出し
  if(
    window.location.pathname.slice(0,11) == '/blogs/blog' ||
    window.location.pathname.slice(0,11) == '/blogs/news'
  ){
    initReadMoreInBlog();
  }

  /* 特定ページ
  ------------------------------ */
  // コレクションページで、スクロールにしたがって画像を表示する
  const showupImageWithScroll = function(){

    // ページになんpx入ったところでアニメーションを始めるか
    const startPos = 200;

    // ターゲット要素のセレクタ
    const selector = '.main-content img';

    // ターゲット要素に、-hidedownクラスを付与
    $(selector).addClass('-hidedown');

    // クラス付与のファンクション
    const addClassShowup = function( selector ){

      // 現在のウィンドウ下限を取得する
      let windowBottom = $(window).scrollTop() + $(window).height();

      // ターゲット要素をひとつづつ精査する
      $(selector).each(function(){

        // 要素の現在の上限位置を取得する
        let currentPos = $(this).offset().top;

        // -showupクラスがなく、要素の上限位置より画面の下限位置下に来たとき、クラスを付与する
        if( !$(this).hasClass('-showup') && currentPos + startPos < windowBottom ){
          $(this).addClass('-showup')
        }
      });
    }

    // スクロール＆リサイズしたときに、クラス付与処理を呼び出す
    $(window).on('scroll resize', function(){
      addClassShowup(selector);
    });

    // 初回実行
    addClassShowup(selector)

  }
  // 特定ページのファンクション呼び出し
  if(
    window.location.pathname.slice(0,18) == '/pages/2020-autumn' ||
    window.location.pathname.slice(0,18) == '/pages/2020-winter' ||
    window.location.pathname.slice(0,18) == '/pages/2021-spring' ||
    window.location.pathname.slice(0,18) == '/pages/2021-summer' ||
    window.location.pathname.slice(0,16) == '/pages/2021-fall' ||
    window.location.pathname.slice(0,18) == '/pages/2021-winter' ||
    window.location.pathname.slice(0,36) == '/pages/2022-spring-summer-collection'
  ){
    showupImageWithScroll();
  }

  /* カートページ
  ------------------------------ */
  const initPageCart = function(){

    // （１）数量プルダウンを変更したら、数量を即変更する
    $('[js-update-quantity]').on('change', function(){

      // 数量inputを更新
      $(this).siblings('input.cart__qty-input').val( $(this).val() );

      // 「更新」ボタンをクリック
      $('input[name="update"]').click();
    });

    // （２）「削除する」ボタンを押したら、商品を削除
    $('[data-js-remove-from-cart]').on('click', function(e){
      e.preventDefault();

      // 数量inputを0にする
      $(this).closest('.cart__meta').find('input.cart__qty-input').val( '0' );

      // 「更新」ボタンをクリック
      $('input[name="update"]').click();
    })
  }
  if( $('body').hasClass('template-cart') ){
    initPageCart();
  }

  /* Q&Aページ
  ------------------------------ */
  const initPageFaq = function(){
    $('.faq-q').click(function(){
      $(this).next('.faq-a').slideToggle();
      $(this).toggleClass("-open");
    });
  }
  if( $('div').hasClass('page-faq-detail') ){
    initPageFaq();
  }
  
  
  /* SNAPデータ読み込み（トップページ＆商品詳細ページ）
  ------------------------------ */
  const initPageTopAndProductDetail = function(){

    if( $('body').hasClass('template-product') ){
      loadSnapPageData();
    }else{
      loadSnapPageData2();
    }
  }
  if( $('body').hasClass('template-product') || $('body').hasClass('template-index')){
    initPageTopAndProductDetail();
  }
})();
